'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checksFilter = require('./checks-filter.html');

var _checksFilter2 = _interopRequireDefault(_checksFilter);

var _checksFilter3 = require('./checks-filter.controller');

var _checksFilter4 = _interopRequireDefault(_checksFilter3);

require('./checks-filter.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checksFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template: _checksFilter2.default,
  controller: _checksFilter4.default,
  controllerAs: 'vm'
};

exports.default = checksFilterComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/checks-filter/checks-filter.component.js
 **/